// ==========================================
// Écran de chargement
// ==========================================

import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function LoadingScreen() {
  const { t } = useTranslation();
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsStuck(true), 10000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed inset-0 bg-arcade-dark flex items-center justify-center z-50">
      <div className="text-center">
        {/* Logo animé */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <svg width="64" height="64" viewBox="0 0 24 24" fill="var(--theme-primary)">
            <path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM11 13H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
          </svg>
        </motion.div>
        
        {/* Titre */}
        <motion.h1
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="font-arcade text-xl text-neon-cyan mb-8"
        >
          QPUG
        </motion.h1>
        
        {/* Barre de chargement */}
        <div className="w-64 h-2 bg-arcade-card rounded-full overflow-hidden mx-auto">
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: '100%' }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: 'linear',
            }}
            className="h-full w-1/2 bg-gradient-to-r from-transparent via-neon-cyan to-transparent"
          />
        </div>
        
        {/* Texte de chargement */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-arcade-muted mt-4 font-retro text-lg"
        >
          {t('common.loading')}
        </motion.p>

        {isStuck && (
          <div className="mt-4 text-center">
            <p className="text-gray-400 text-sm mb-2">Loading is taking longer than usual.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-lg text-sm font-bold transition-all border border-gray-600 hover:border-gray-400 text-white"
            >
              Refresh page
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

